export default "<label for=\"mode-checkbox\">Ladder only</label>\n<input type=\"checkbox\" [formControl]=\"modeControl\" id=\"mode-checkbox\">\n"